// Shared across every proposal: brand assets, the sample hero photo, legal disclaimers and the default theme.
// Edit here once; every client's page picks it up.

export const assets = {
  logoOnLight: "logos/aht-logo-gold-house-dark-text.png",
  logoOnDark: "logos/aht-logo-gold-house-white-text.png",
  expOnLight: "logos/exp-realty-logo-black.png",
  expOnDark: "logos/exp-realty-logo-white.png",
  signatureOnDark: "logos/adam-signature-white.png",
  portraitNegotiation: "adam/adam-expert-standing.webp",
  portraitThankYou: "adam/adam-thank-you-seated.webp",
};

// Used when a proposal's meta.heroMode is "sample" (no photo of the client's home yet).
export const sampleHeroPhoto = {
  sources: [
    { src: "listings/bellevue-twilight-listed-by-adam-800.webp", width: 800 },
    { src: "listings/bellevue-twilight-listed-by-adam-1200.webp", width: 1200 },
    { src: "listings/bellevue-twilight-listed-by-adam.webp", width: 1482 },
  ],
  alt: "Twilight exterior of a Bellevue home listed by Adam",
  label: "Sample photo from one of my Bellevue listings",
};

export const disclaimers = {
  market: "All market reports published October 2026, based on data available at the end of September 2026. Information and statistics derived from Northwest Multiple Listing Service. Neither the Board nor its MLS guarantees or is in any way responsible for its accuracy. Data maintained by the Board or its MLS may not reflect all real estate activity in the market. Market Synopsis copyright TrendGraphix, Inc.",
  equalHousing: "Equal Housing Opportunity.",
};

// Default theme name from src/theme/themes.js
export const theme = "signature";
